<template>
  <div class="answers_choice">
    <vcirclelabel
      v-for="item in data"
      :key="item.id"
      class="answer"
      :value="item.id === selected_id"
      :label="item.body"
      :disabled="isDisabled"
      @input="set_selected_id(item.id)"
    />
  </div>
</template>

<script>
export default {
  name: 'AnswersChoice',

  props: ['data', 'isDisabled'],

  data() {
    return {
      selected_id: null
    };
  },

  methods: {
    set_selected_id(v) {
      this.selected_id = v;
      this.$emit('update', [{ id: v }]);
    }
  }
};
</script>

<style lang="scss" scoped>
.answers_choice {
  .answer {
    cursor: pointer;
    &:hover {
      background-color: #f4f5f7;
    }
  }

  ::v-deep {
    .answer.vcircle_label {
      margin-bottom: 8px;
      padding: 0;
      &:hover {
        background: transparent;
      }

      &:last-child {
        margin-bottom: 0;
      }

      .circle_label {
        font-size: 15px;
        line-height: 24px;
      }
    }
  }
}
</style>
